import accounting from 'accounting';

// TODO: Complete all available currency formats
const formats = {
    GBP: {
        symbol: '£',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    USD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    AUD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    CAD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    MXN: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    MAD: {
        symbol: 'د.م.‏',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v%s',
    },
    EUR: {
        symbol: '€',
        decimal: ',',
        thousand: ' ',
        precision: 2,
        format: '%v %s',
    },
    TRY: {
        symbol: '₺',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    AED: {
        symbol: 'د.إ',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%v%s',
    },
    SEK: {
        symbol: 'kr',
        decimal: ',',
        thousand: '.',
        precision: 0,
        format: '%v %s',
    },
    ISK: {
        symbol: 'kr',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v %s',
    },
    JOD: {
        symbol: 'د.أ',
        decimal: '.',
        thousand: ',',
        precision: 3,
        format: '%v%s',
    },
    NZD: {
        symbol: '$',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s%v',
    },
    ZAR: {
        symbol: 'R',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s %v',
    },
    PLN: {
        symbol: 'zl',
        decimal: '.',
        thousand: ',',
        precision: 2,
        format: '%s %v',
    },
};

export default {
    methods: {
        formatMoney: function(number, currency = 'GBP') {
            return accounting.formatMoney(number, formats[currency]).replace(' ',' ');//add nbsp;
        },

        price(product) {
            return this.formatMoney(
                product.total_price,
                this.selectedCurrency.code
            );
        },

        originalPrice(product) {
            return this.formatMoney(
                product.original_price,
                this.selectedCurrency.code
            );
        },

        selectedPriceDiffBasePrice(selectedProduct, product, hire_days) {
            // Return ONLY the absolute difference in price, per day (ie, always a positive number)
            return this.formatMoney((Math.abs(product.total_price - selectedProduct.total_price) / hire_days), this.selectedCurrency.code);
        },

        insuranceDepositPrice(product) {
            return this.formatMoney(
                product.insurance_deposit,
                this.selectedCurrency.code
            ).replace(/\.00$/gi, '');
        },

        insuranceExcessPrice(product) {
            return this.formatMoney(
                product.insurance_excess,
                this.selectedCurrency.code
            ).replace(/\.00$/gi, '');
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/accounting.js